import { clientOnlyHook } from '@beef/utils';
import { useBusListener, useCommandBus } from '@beefco/bus/react';
import { useEventListener } from '@beef/react';
import { ForwardNativeKeyboardEventCommand, ForwardNativeMouseEventCommand, ForwardedWheelEventCommand } from "../commands";
import { injectStandardEventProps, offsetMouseEvent, pickImportantWheelEventFields } from "./helpers";
import { ForwardedKeyboardEvent, ForwardedMouseEvent } from "../utils/events";

/**
 * Ловим и симулируем нативные события из EventTransmitter'а
 * Used in Platform-GUI
 */
export var useEventReceiver = clientOnlyHook(function (frameRef, overlayRef) {
  useBusListener(ForwardNativeMouseEventCommand, function (event) {
    if (!frameRef.current) throw Error('Should never hit this condition');
    var _frameRef$current$get = frameRef.current.getBoundingClientRect(),
      left = _frameRef$current$get.left,
      top = _frameRef$current$get.top;
    var simulatedEvent = new ForwardedMouseEvent(event.type, injectStandardEventProps(offsetMouseEvent(event, {
      left: left,
      top: top
    })));
    document.dispatchEvent(simulatedEvent);
  });
  useBusListener(ForwardNativeKeyboardEventCommand, function (event) {
    var simulatedEvent = new ForwardedKeyboardEvent(event.type, injectStandardEventProps(event));
    document.dispatchEvent(simulatedEvent);
  });
  var bus = useCommandBus();
  useEventListener('wheel', function (event) {
    var domTargets = [overlayRef.current, frameRef.current].filter(Boolean);
    if (!domTargets.some(function (el) {
      return el.contains(event.target);
    })) return;
    bus.execute(new ForwardedWheelEventCommand(pickImportantWheelEventFields(event)));
  }, document);
});